import { useRecordContext } from "react-admin";

export const SkidTitle = ({ prefix }: { prefix?: string }) => {
    const record = useRecordContext();
    if (!record) return null;
    return <span>{prefix ? `${prefix} `: ''}Skid: {record.name}</span>;
};